module.exports = __webpack_public_path__ + "img/9788983782854.808f0d73.jpg";